import { render, staticRenderFns } from "./MediaCollectionItem.vue?vue&type=template&id=60e5c449&scoped=true"
import script from "./MediaCollectionItem.vue?vue&type=script&lang=js"
export * from "./MediaCollectionItem.vue?vue&type=script&lang=js"
import style0 from "./MediaCollectionItem.vue?vue&type=style&index=0&id=60e5c449&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e5c449",
  null
  
)

export default component.exports